import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Popup from './Componentes/Popup';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Popup />
);
